import React, { useCallback } from 'react';
import Button from 'src/components/primitives/Button/Button';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';
import useModal from 'src/components/Modals/hooks/useModal';
import useCloseMultiplePositions from 'src/hooks/positions/useCloseMultiplePositions';

export interface CloseAllPositionsModalProps {
	perpMarketIndexesToClose: number[];
}

export default function CloseAllPositionsModal({
	perpMarketIndexesToClose,
}: CloseAllPositionsModalProps) {
	const { hide } = useModal();
	const closeMultiplePositions = useCloseMultiplePositions();

	const handleConfirm = useCallback(async () => {
		const toastId = `close-all-positions-${Date.now()}`;
		await closeMultiplePositions(toastId, perpMarketIndexesToClose, true);

		hide();
	}, [perpMarketIndexesToClose, hide, closeMultiplePositions]);

	return (
		<ResponsiveModal.Container
			onClose={hide}
			dataTestId="close-all-positions-modal"
		>
			<ResponsiveModal.Title closeButtonTestId="close-all-positions-modal-close">
				Market close all
			</ResponsiveModal.Title>
			<ResponsiveModal.Body>
				This will close all of your positions and cancel their associated open
				orders.
			</ResponsiveModal.Body>
			<ResponsiveModal.Footer>
				<Button
					className="w-full"
					size="lg"
					variant="primary"
					onClick={handleConfirm}
					dataTestId="close-all-positions-modal-submit"
				>
					Market close
				</Button>
			</ResponsiveModal.Footer>
		</ResponsiveModal.Container>
	);
}
